
<div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div class="mt-10 text-normal" #contentContainer [innerHTML]="componentModel?.content?.value">
    </div>
</div>

